import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";
import WorkerDashboard from "@/pages/WorkerDashboard";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import AcceptInvite from "@/pages/AcceptInvite";
import ErrorBoundary from "@/components/ErrorBoundary";
import { Toaster } from "sonner";
import "@/App.css";

function Protected({ children, role }) {
  const { user } = useAuth();
  if (user === undefined) {
    return <div className="h-screen grid place-items-center text-gray-500">Loading…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/worker"} replace />;
  }
  return children;
}

export default function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="bottom-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/invite/:token" element={<AcceptInvite />} />
            <Route
              path="/admin"
              element={<Protected role="admin"><AdminDashboard /></Protected>}
            />
            <Route
              path="/worker"
              element={<Protected role="worker"><WorkerDashboard /></Protected>}
            />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}
